import { FilterSections } from './filter_sections';

const FilterSectionLabelTranslationKeys = {
    [FilterSections.TYRE_INDEX_VIEW]: 'catalog-filters-headline-tyre-index',
    [FilterSections.BRAND_VIEW]: 'catalog-filters-headline-tyre-brand',
    [FilterSections.PRICE_VIEW]: 'catalog-filters-headline-price',
    [FilterSections.DEALS_VIEW]: 'catalog-filters-headline-tyre-deals',
    [FilterSections.FEATURES_VIEW]: 'catalog-filters-headline-tyre-features',
    [FilterSections.ADDITIONAL_VIEW]: 'catalog-filters-headline-tyre-additional',
    [FilterSections.FITMENT_VIEW]: 'catalog-filters-headline-tyre-fitments',
    [FilterSections.WHEEL_BRAND_VIEW]: 'catalog-filters-headline-wheel-brand',
    [FilterSections.WHEEL_BOLT_PATTERN_VIEW]: 'catalog-filters-headline-wheel-bolt-pattern',
    [FilterSections.WHEEL_SIZE_VIEW]: 'catalog-filters-headline-wheel-size',
    [FilterSections.USAGE_VIEW]: 'catalog-filters-section-headline-usage',
    [FilterSections.TECHNOLOGY_VIEW]: 'catalog-filters-section-headline-technology',
    [FilterSections.TYRE_RATINGS_VIEW]: 'catalog-filters-section-headline-tyre-ratings',
    [FilterSections.CUSTOMER_REVIEWS_VIEW]: 'catalog-filters-section-headline-customer-reviews',
    [FilterSections.QUALITY_SEGMENT_VIEW]: 'catalog-filters-section-headline-quality-segment',
    [FilterSections.SEASON_VIEW]: 'catalog-filters-section-headline-season',
    [FilterSections.EV_VIEW]: 'catalog-filters-section-headline-ev',
};

export { FilterSectionLabelTranslationKeys };